import React from 'react';
import { PlayIcon, VideoIcon } from 'lucide-react';
interface VideoPanelProps {
  title: string;
  caption?: string;
  videoUrl?: string;
  /** Wistia media id — rendered through Wistia's iframe embed. */
  wistiaId?: string;
  eyebrow?: string;
  duration?: string;
  compact?: boolean;
}
export function VideoPanel({
  title,
  caption,
  videoUrl,
  wistiaId,
  eyebrow,
  duration,
  compact = false
}: VideoPanelProps) {
  const src = videoUrl ?? (wistiaId ? `https://fast.wistia.net/embed/iframe/${wistiaId}?videoFoam=false` : undefined);
  return <figure className="w-full" data-id="element-49" data-mp="skoipogd2wpf">
      <div className="relative w-full overflow-hidden rounded-xl border border-white/10 bg-ink-850 shadow-[0_18px_50px_-30px_rgba(0,0,0,0.9)] sm:rounded-2xl" data-id="element-50" data-mp="slgg94tir4ic">
        <div className="aspect-video w-full" data-id="element-51" data-mp="wo39991xevh4">
          {src ? <iframe src={src} title={title} className="h-full w-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" allowFullScreen data-id="element-52" data-mp="2mz7k1np62u5v" /> : <div className="flex h-full w-full flex-col items-center justify-center gap-2.5 bg-[radial-gradient(circle_at_50%_35%,rgba(30,147,232,0.14),transparent_60%)] px-5 text-center sm:gap-4" role="img" aria-label={`${title} — video placeholder`} data-id="element-53" data-mp="2ish73it7um4h">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-500/15 ring-1 ring-brand-400/40 sm:h-16 sm:w-16" data-id="element-54" data-mp="24tznnxacfvsd">
                <PlayIcon className="h-5 w-5 translate-x-[1px] fill-brand-300 text-brand-300 sm:h-6 sm:w-6" aria-hidden="true" data-id="element-55" data-mp="2erng2gkh8r7d" />
              </span>
              <div data-id="element-56" data-mp="3q6k9s3rlw4l2">
                <p className={`font-semibold text-white ${compact ? 'text-sm' : 'text-sm sm:text-lg'}`} data-id="element-57" data-mp="3q613xlf8d6ne">
                  {title}
                </p>
                <p className="mt-0.5 text-xs text-white/40 sm:text-sm" data-id="element-58" data-mp="3sa4i2ry8hkou">
                  Video plays here once attached.
                </p>
              </div>
            </div>}
        </div>

        {(eyebrow || duration) && !src && <div className="pointer-events-none absolute inset-x-0 top-0 flex items-center justify-between p-2.5 sm:p-4" data-id="element-59" data-mp="b2smk5iozzga">
            {eyebrow ? <span className="inline-flex items-center gap-1.5 rounded-full bg-black/50 px-2.5 py-1 text-[11px] font-semibold text-white/70 backdrop-blur sm:text-xs" data-id="element-60" data-mp="39lr6i70b9klp">
                <VideoIcon className="h-3 w-3 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-61" data-mp="3ji2kr2jgokis" />
                {eyebrow}
              </span> : <span data-id="element-62" data-mp="3oanc7xewalj5" />}
            {duration && <span className="rounded-full bg-black/50 px-2.5 py-1 text-[11px] font-medium text-white/60 backdrop-blur sm:text-xs" data-id="element-63" data-mp="2qsvlu2g3hsx0">
                {duration}
              </span>}
          </div>}
      </div>

      {caption && <figcaption className={`mx-auto mt-2.5 max-w-2xl text-center italic text-white/45 sm:mt-4 sm:text-center ${compact ? 'text-xs sm:text-sm' : 'text-sm sm:text-base'}`} data-id="element-64" data-mp="1cvkihowsjvgh">
          {caption}
        </figcaption>}
    </figure>;
}